module.exports = __webpack_public_path__ + "media/assets/images/payments/airplus-396306e6781e8469ac5f6e04ec06ae15.png";